// extracted by mini-css-extract-plugin
module.exports = {"container":"actionContent_container__1am3H","content":"actionContent_content__1hWQC"};